import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { get_platform_notice } from "../../services/common";
import {
  PLATFORM_NOTICE_DISMISSED_KEY,
  PLATFORM_NOTICE_FETCHED_KEY,
} from "../../Utils/platformNoticeSession";
import PlatformNoticeModal from "./PlatformNoticeModal";

const PlatformNotice = () => {
  const [notice, setNotice] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("jwtToken");
    if (!token) return;

    if (sessionStorage.getItem(PLATFORM_NOTICE_DISMISSED_KEY) === "true") {
      return;
    }

    if (sessionStorage.getItem(PLATFORM_NOTICE_FETCHED_KEY) === "true") {
      return;
    }

    sessionStorage.setItem(PLATFORM_NOTICE_FETCHED_KEY, "true");

    const fetchNotice = async () => {
      try {
        const response = await get_platform_notice();
        if (
          response?.status === 200 &&
          response?.platform_notice === true &&
          (response?.notice_title || response?.notice_message)
        ) {
          setNotice({
            title: response.notice_title || "Platform Notice",
            message: response.notice_message || "",
          });
          setIsVisible(true);
        }
      } catch (error) {
        console.error("Failed to load platform notice:", error);
      }
    };

    fetchNotice();
  }, [location.pathname]);

  const handleClose = () => {
    sessionStorage.setItem(PLATFORM_NOTICE_DISMISSED_KEY, "true");
    setIsVisible(false);
  };

  if (!isVisible || !notice) return null;

  return (
    <PlatformNoticeModal
      title={notice.title}
      message={notice.message}
      onClose={handleClose}
    />
  );
};

export default PlatformNotice;
